import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Card,
  CardHeader,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  IconButton,
  Box,
  Fade,
  Grow,
  TextField,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import { BASE_URL } from "./../../Api/ApiUrls";
import {
  Add as AddIcon,
  Remove as RemoveIcon,
  Edit as EditIcon,
  Save as SaveIcon,
} from "@mui/icons-material";
import AdminDashboard from "../../Admin/Dashboard/Dashboard";

const ConstructionPackages = () => {
  const [expanded, setExpanded] = useState({});
  const [editableContent, setEditableContent] = useState({});
  const [editingField, setEditingField] = useState(null);
  const [tempContent, setTempContent] = useState({});
  const [packageData, setPackageData] = useState({});
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [editingPackageCost, setEditingPackageCost] = useState(false);
  const [tempPackageCost, setTempPackageCost] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const [sectionContent, setSectionContent] = useState({
    package2800: {
      design:
        "• <strong>2D Floor Plans</strong> \n• <strong>3D Elevations</strong> \n• <strong>Structural Drawing</strong> \n• <strong>Plumbing & Electrical Layout</strong> \n• <strong> Working Drawings for Execution, Schedule of Openings</strong>",
      foundation:
        "• <strong>Underground Sump (6″ Solid Block, Waterproof Plastered) </strong> \n• <strong>Two-Course Size Stone Masonry Under Plinth </strong> \n• <strong>Ceiling Height: 10 Feet (Floor to Floor) </strong> \n• <strong>Waterproofing: Dr. Fixit or Fosroc </strong>",
      materials:
        "• <strong>Steel:</strong> Fe500/550 Grade TMT – Indus, Prime Gold, JSW, or Tata Equivalent\n• <strong>Cement:</strong> 53 & 43 Grades (Birla, ACC, Ultratech, or Equivalent)\n• <strong>Aggregates:</strong> 20MM & 40MM\n• <strong>Sand:</strong> M-Sand for Blockwork, P-Sand for Plastering\n• <strong>Blocks:</strong> Solid Blocks (6″ {55 per pic} & 4″ {45 per pic})\n• <strong>Concrete Mix:</strong> RMC – M20 Grade",
      flooring:
        "• <strong>Living, Kitchen, Dining & Bedroom:</strong> ₹60/sq. ft.\n• <strong>Staircase:</strong> Granite up to ₹80/sq. ft.\n• <strong>Balconies & Sitouts:</strong> Anti-skid tiles up to ₹60/sq. ft.\n• <strong>Bathrooms/Toilets Wall & Flooring:</strong> ₹60/sq. ft.\n• <strong>Parking Area:</strong> Flooring up to ₹50/sq. ft.\n• <strong>Kitchen Countertop:</strong> Granite up to ₹100/sq. ft.\n• <strong>Kitchen Backsplash (Dadoing, 4ft height):</strong> Tiles up to ₹50/sq. ft.\n• <strong>Bathroom Wall Tiling:</strong> Up to 7 feet height\n• <strong>Terrace Finishing:</strong> Screed concrete",
      // windows:
      //   "• <strong>Standard Windows:</strong> 2-track UPVC with 5mm glass & MS grill (₹550/sq. ft.)\n• <strong>3-track UPVC with 5mm glass & MS grill (₹700/sq. ft.) or Sal wood frames with shutters\n• <strong>Maximum Window Coverage:</strong> 10% of total wall space",
      doors:
        "• <strong>Window:</strong> o	3-Track UPVC with 5mm Glass & MS Grill (Budget ₹850/- per sq. ft.) o	Maximum Opening Percentage: 15% • <strong>Main Door:</strong> Teakwood frame (5″x3″) with teak shutter & fittings (₹22,000 per door)\n• <strong>Pooja Room Door:</strong> Frame (5″x3″) with readymade shutter & fittings (₹20,000 per door)\n• <strong>Internal Doors:</strong> WPC or neem wood frame (4″x3″) with membrane shutter & fittings (₹8,000 per door)\n• <strong>Bathroom Doors:</strong> PVC/WPC doors",
      painting:
        "• <strong>Interior Walls & Ceilings:</strong> 2 Coats Putty + 1 Coat Primer + 2 Coats of Asian Royale \n• <strong>Exterior Walls:</strong> 1 Coat Primer + 2 Coats of APEX ultima\n• <strong>Windows & MS Grills:</strong> 2 Coats of Enamel Paint\n• <strong>Brands Considered:</strong> Asian, Berger, Dulux (Owner's Choice)",
      fabrication:
        "• <strong>MS Staircase Railing:</strong> ₹300 per sq. ft. (3′6'' height)\n• <strong>MS Standard Gate:</strong> ₹350 per sq. ft. (6′ height)",
      plumbing:
        "• <strong>Pipes:</strong> Ashirwad / Supreme / Astral CPVC \n• <strong>Overhead Tank:</strong> PVC Overhead Tank (Ganga/Kaveri) with MS Structure (6' height)\n• <strong>Solar & Geyser Provision:</strong> Diverter and mixer-ready\n• <strong>Sanitary Installations:</strong>\n o <strong>Overhead tank:</strong> ₹1,000\n o <strong>Commode:</strong> ₹6,500\n o <strong>Wall mixer:</strong> ₹3,500",
      extra:
        "• <strong> Liaison Work: </strong> BBMP/BDA or other approving bodies \n• <strong>	Extra Civil Work</strong> \no	Floor Level more than 18″ above Road Level \n o	Outside Ramping &Extra SumpDepth , Rain water sump \no	Interior Works (Wardrobe, False Ceiling, etc.) \no	External Cladding for Elevation \no	Landscaping & Security Fabrication Work \no	Any Civil Work outside House Area Road cutting \n o	Additional Height for Compound <strong>\n•	Electrical Fittings: </strong> Light Tubes, Bulbs, Fans, etc., not included \n• <strong> Soil Bearing Capacity (SBC):</strong> Extra charges if SBC < 180",
      sanctions:
        " Assistance for\n• <strong>Construction Plan Sanction</strong>\n• <strong>Temporary Electricity Connection</strong>\n• <strong>Permanent Electrical Connection</strong>\n• <strong>Water Connection</strong>\n• <strong>Sewage Connection</strong>",
      elevation:
        "<strong>• 1.25% of Project Super built Cost </strong> \n• <strong>Soil Testing :</strong> Extra charges \n• <strong>Site Supervision :</strong> Civil Engineer & PM assigned \n• <strong>Architect Visits :</strong> Extra charges",
      audit:
        "• <strong>Soil Testing:</strong> Additional charges\n• <strong>Site Supervision:</strong> Civil Engineer & Project Manager assigned\n• <strong>Architect Visits:</strong> Additional charges",
    },
  });

  // Fetch data from API
  const fetchPackageData = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${BASE_URL}/packages/4/`);
      setPackageData(response.data);
      updateSectionContent(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching package data:", error);
      setSnackbar({
        open: true,
        message: "Failed to fetch package data",
        severity: "error",
      });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPackageData();
  }, []);

  const updateSectionContent = (data) => {
    const updatedSectionContent = {
      package2800: {
        ...sectionContent.package2800,
        flooring: `• <strong>Living, Kitchen, Dining & Bedroom:</strong> ₹${
          data.tile_general || 0
        }/- per sq. ft.
• <strong>Staircase:</strong> Granite up to ₹${data.tile_stair || 0}/- per sq. ft.
• <strong>Balconies & Sitouts:</strong> Anti-skid tiles up to ₹${
          data.tile_balcony || 0
        }/- per sq. ft.
• <strong>Bathrooms/Toilets Wall & Flooring :</strong>  ₹${
          data.title_bathroom || 0
        }/- per sq. ft.
• <strong>Parking Floor :</strong> ₹${
          data.tile_parking || 0
        }/- per sq. ft.
• <strong>Kitchen Countertop:</strong> ₹${
          data.tile_kitchen_countertop || 0
        }/- per sq. ft.
• <strong>Kitchen Dadoing (2 feet tiles):</strong> ₹${
          data.tile_kitchen_backsplash || 0
        }/- per sq. ft.
• <strong>Bathroom Dadoing (10 feet height): </strong> Included
• <strong>Terrace :</strong> Screed concreting`,
//         windows: `• <strong>Standard Windows:</strong> 2-track UPVC with 5mm glass & MS grill (₹${
//           data.window_standered || 0
//         }/- per sq. ft.)
// • <strong>Maximum Window Openings:</strong> 2.5-track Aluminum with 4mm glass & MS grill
// • <strong>Maximum Window Coverage:</strong> 10% of total wall space`,
        doors: `
        • <strong>Window:</strong> \no	3-Track UPVC with 5mm Glass & MS Grill (Budget ₹850/- per sq. ft.) \no	Maximum Opening Percentage: 15%
        • <strong>Main Door:</strong> Teakwood frame (6″x6″) + Teak Door Shutter (₹${
          data.doors_main || 0
        } per door)
• <strong>Pooja Door:</strong> Frame (5″x3″) with Readymade Door (₹${
          data.doors_pooja || 0
        } per door)
• <strong>Internal Doors:</strong> WPC/Sal Frame (4″X3″) + Membrane Door Shutter (₹${
          data.doors_internal || 0
        } per door)
• <strong>Bathroom Doors:</strong> WPC doors`,
        fabrication: `• <strong>MS Staircase Railing:</strong> ₹${
          data.fabrication_stair_rail || 0
        } per sq. ft. (3′6'' height)
• <strong>MS Standard Gate:</strong> ₹${
          data.fabrication_gate || 0
        } per sq. ft. (6′ height)`,
        plumbing: `• <strong>Pipes:</strong> Ashirwad / Supreme / Astral CPVC
• <strong>Water Tank:</strong> PVC Overhead Tank (Ganga/Kaveri) with MS Structure (6' height)
• <strong>Solar & Geyser Provision:</strong> Provided for Diverters/Mixtures Only
• <strong>Sewage Chambers:</strong>
 o <strong>PVC Cover Inside Plot Area (Overhead Tank</strong> ₹${data.sanitary_overheadtank || 0} , Commode: ₹${data.sanitary_commode || 0} , Wall mixer: ₹${data.sanitary_wallmixer || 0}`,
      },
    };
    setSectionContent(updatedSectionContent);
  };

  const handleEditPackageCost = () => {
    setTempPackageCost(packageData.package_cost?.toString() || "0");
    setEditingPackageCost(true);
  };

  const handleSavePackageCost = async () => {
    try {
      await axios.put(`${BASE_URL}/packages/4/`, {
        package_cost: parseInt(tempPackageCost) || 0,
      });

      // Refresh data after successful update
      await fetchPackageData();

      setEditingPackageCost(false);
      setSnackbar({
        open: true,
        message: "Package cost updated successfully",
        severity: "success",
      });
    } catch (error) {
      console.error("Error updating package cost:", error);
      setSnackbar({
        open: true,
        message: "Failed to update package cost",
        severity: "error",
      });
    }
  };

  const handleChange = (panel, packageType) => (event, newExpanded) => {
    setExpanded((prev) => ({
      ...prev,
      [packageType]: newExpanded ? panel : null,
    }));
  };

  const extractRupeeValues = (content) => {
    const rupeeRegex = /₹(\d+)/g;
    const matches = [...content.matchAll(rupeeRegex)];
    return matches.map((match) => ({
      value: match[0],
      index: match.index,
      length: match[0].length,
    }));
  };

  // const handleEdit = (pkgId, sectionId, content) => {
  //   setTempContent((prev) => ({
  //     ...prev,
  //     [`${pkgId}-${sectionId}`]: content,
  //   }));
  //   setEditingField(`${pkgId}-${sectionId}`);
  // };

  const handleEdit = (pkgId, sectionId, content) => {
    setEditingField(`${pkgId}-${sectionId}`);
    setTempContent((prev) => ({
      ...prev,
      [`${pkgId}-${sectionId}`]: content,
    }));

    // Expand the accordion
    setExpanded((prev) => ({
      ...prev,
      [pkgId]: sectionId,
    }));
  };

  const handleSave = async (pkgId, sectionId) => {
    try {
      const content =
        tempContent[`${pkgId}-${sectionId}`] ||
        sectionContent.package2800[
          sectionId.replace("pkg2800", "").toLowerCase()
        ];
      const rupeeValues = extractRupeeValues(content);

      if (rupeeValues.length == 0) {
        setEditableContent((prev) => ({
          ...prev,
          [`${pkgId}-${sectionId}`]: content,
        }));
        setEditingField(null);
        return;
      }

      let updatePayload = {};
      const sectionKey = sectionId.replace("pkg2800", "").toLowerCase();

      switch (sectionKey) {
        case "three": // Flooring section
          const flooringValues = content.match(/₹(\d+)/g) || [];
          updatePayload = {
            tile_general: extractNumber(flooringValues[0]),
            tile_stair: extractNumber(flooringValues[1]),
            tile_balcony: extractNumber(flooringValues[2]),
            title_bathroom: extractNumber(flooringValues[3]),
            tile_parking: extractNumber(flooringValues[4]),
            tile_kitchen_countertop: extractNumber(flooringValues[5]),
            tile_kitchen_backsplash: extractNumber(flooringValues[6]),
          };
          break;
        case "four": // Windows section
          const windowValue = content.match(/₹(\d+)/);
          updatePayload = {
            window_standered: windowValue ? extractNumber(windowValue[0]) : 0,
          };
          break;
        case "five": // Doors section
          const doorValues = content.match(/₹(\d+)/g) || [];
          updatePayload = {
            doors_main: extractNumber(doorValues[0]),
            doors_pooja: extractNumber(doorValues[1]),
            doors_internal: extractNumber(doorValues[2]),
          };
          break;
        case "seven": // Fabrication section
          const fabricationValues = content.match(/₹(\d+)/g) || [];
          updatePayload = {
            fabrication_stair_rail: extractNumber(fabricationValues[0]),
            fabrication_gate: extractNumber(fabricationValues[1]),
          };
          break;
        case "eight": // Plumbing section
          const plumbingValues = content.match(/₹(\d+)/g) || [];
          updatePayload = {
            sanitary_overheadtank: extractNumber(plumbingValues[0]) || 0,
            sanitary_commode: extractNumber(plumbingValues[1]) || 0,
            sanitary_wallmixer: extractNumber(plumbingValues[2]) || 0,
          };
          break;
        default:
          break;
      }

      // Filter out undefined values
      const filteredPayload = Object.fromEntries(
        Object.entries(updatePayload).filter(([_, v]) => v !== undefined)
      );

      if (Object.keys(filteredPayload).length > 0) {
        await axios.put(`${BASE_URL}/packages/4/`, filteredPayload);

        // Refresh data after successful update
        await fetchPackageData();

        setSnackbar({
          open: true,
          message: "Package updated successfully",
          severity: "success",
        });
      }

      setEditableContent((prev) => ({
        ...prev,
        [`${pkgId}-${sectionId}`]: content,
      }));
      setEditingField(null);
    } catch (error) {
      console.error("Error updating package:", error);
      setSnackbar({
        open: true,
        message: "Failed to update package",
        severity: "error",
      });
    }
  };

  const extractNumber = (value) => {
    if (!value) return 0;
    const num = value.replace(/[^0-9]/g, "");
    return num ? parseInt(num, 10) : 0;
  };

  const handleRupeeValueChange = (
    pkgId,
    sectionId,
    content,
    index,
    length,
    newValue
  ) => {
    // Remove all non-numeric characters
    let numericValue = newValue.replace(/[^0-9]/g, "");

    // If the field is empty or would become empty, set it to '0'
    if (numericValue === "") {
      numericValue = "0";
    }
    // Remove leading zeros unless it's the only digit
    else if (numericValue.length > 1) {
      numericValue = numericValue.replace(/^0+/, "");
      if (numericValue === "") numericValue = "0";
    }

    const formattedValue = `₹${numericValue}`;

    const newContent =
      content.substring(0, index) +
      formattedValue +
      content.substring(index + length);

    setTempContent((prev) => ({
      ...prev,
      [`${pkgId}-${sectionId}`]: newContent,
    }));
  };

  const renderContentWithEditableRupeeValues = (pkgId, sectionId, content) => {
    if (editingField !== `${pkgId}-${sectionId}`) {
      return <span dangerouslySetInnerHTML={{ __html: content }} />;
    }

    const rupeeValues = extractRupeeValues(content);
    if (rupeeValues.length == 0) {
      return <span dangerouslySetInnerHTML={{ __html: content }} />;
    }

    let lastPos = 0;
    const elements = [];

    rupeeValues.forEach((rupee, i) => {
      if (rupee.index > lastPos) {
        elements.push(
          <span
            key={`text-${i}`}
            dangerouslySetInnerHTML={{
              __html: content.substring(lastPos, rupee.index),
            }}
          />
        );
      }

      elements.push(
        <TextField
          key={`edit-${i}`}
          value={
            rupee.value.replace("₹", "") === "0"
              ? ""
              : rupee.value.replace("₹", "")
          }
          onChange={(e) => {
            handleRupeeValueChange(
              pkgId,
              sectionId,
              tempContent[`${pkgId}-${sectionId}`],
              rupee.index,
              rupee.length,
              e.target.value
            );
          }}
          onFocus={(e) => {
            if (e.target.value === "0") {
              e.target.value = "";
            }
          }}
          onBlur={(e) => {
            if (e.target.value === "") {
              e.target.value = "0";
              handleRupeeValueChange(
                pkgId,
                sectionId,
                tempContent[`${pkgId}-${sectionId}`],
                rupee.index,
                rupee.length,
                "0"
              );
            }
          }}
          size="small"
          sx={{
            display: "inline-block",
            width: "80px",
            mx: 0.5,
            "& .MuiInputBase-root": {
              height: "32px",
            },
            "& .MuiInputBase-input": {
              textAlign: "right",
            },
          }}
          inputProps={{
            inputMode: "numeric",
            pattern: "[0-9]*",
          }}
        />
      );

      lastPos = rupee.index + rupee.length;
    });

    if (lastPos < content.length) {
      elements.push(
        <span
          key="text-end"
          dangerouslySetInnerHTML={{
            __html: content.substring(lastPos),
          }}
        />
      );
    }

    return elements;
  };

  const packages = [
    {
      id: "package2800",
      title: "Construction Package Details",
      price: `Rs ${
        packageData.package_cost
          ? packageData.package_cost + "/sqft"
          : "Loading..."
      }`,
      color: "",
      gradient: "linear-gradient(135deg,rgb(101, 81, 77),rgb(124, 119, 119))",
      sections: [
        {
          id: "pkg2800One",
          title: "Design & Drawings",
          content: sectionContent.package2800.design,
        },
        {
          id: "pkg2800Two",
          title: "Materials & Construction",
          content: sectionContent.package2800.materials,
        },
        {
          id: "pkg2800Three",
          title: "Foundation & Waterproofing",
          content: sectionContent.package2800.foundation,
        },
        {
          id: "pkg2800Four",
          title: "Flooring & Finishing",
          content: sectionContent.package2800.flooring,
        },
        // {
        //   id: "pkg2800Five",
        //   title: "Windows & Doors",
        //   content: sectionContent.package2800.windows,
        // },
        {
          id: "pkg2800Six",
          title: "Windows & Doors",
          content: sectionContent.package2800.doors,
        },
        {
          id: "pkg2800Seven",
          title: "Painting & Finishing",
          content: sectionContent.package2800.painting,
        },
        {
          id: "pkg2800Eight",
          title: "Railings & Gate",
          content: sectionContent.package2800.fabrication,
        },
        {
          id: "pkg2800Nine",
          title: "Plumbing & Sanitary",
          content: sectionContent.package2800.plumbing,
        },
        {
          id: "pkg2800Ten",
          title: "Exclusions & Additional Charges",
          content: sectionContent.package2800.extra,
        },
        {
          id: "pkg2800Eleven",
          title: "Government Approvals & Utilities",
          content: sectionContent.package2800.sanctions,
        },
        {
          id: "pkg2800Twelve",
          title: "Additional Charges",
          content: sectionContent.package2800.elevation,
        },
        // {
        //   id: "pkg2800thirteen",
        //   title: "Site Audit & Reporting",
        //   content: sectionContent.package2800.audit,
        // },
      ],
    },
  ];

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <>
      <Fade in={true} timeout={800}>
        <Box>
          <Box>
            {isLoading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "200px",
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              packages.map((pkg, index) => (
                <Grow in={true} timeout={index * 200 + 400} key={pkg.id}>
                  <Card
                    sx={{
                      borderRadius: "16px",
                      boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                      overflow: "hidden",
                      transition: "transform 0.4s, box-shadow 0.4s",
                      "&:hover": {
                        transform: "translateY(-8px)",
                        boxShadow: "0 15px 35px rgba(0,0,0,0.15)",
                      },
                      border: "none",
                      width: "100%",
                      // height: "700px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <CardHeader
                      title={
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: 700,
                            color: "white",
                            fontSize: "1.6rem",
                            letterSpacing: "0.5px",
                          }}
                        >
                          {pkg.title}
                        </Typography>
                      }
                      subheader={
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {editingPackageCost ? (
                            <TextField
                              value={tempPackageCost}
                              onChange={(e) =>
                                setTempPackageCost(
                                  e.target.value.replace(/\D/g, "")
                                )
                              }
                              size="small"
                              sx={{
                                width: "120px",
                                mr: 1,
                                "& .MuiInputBase-input": {
                                  color: "white",
                                  textAlign: "center",
                                },
                                "& .MuiOutlinedInput-root": {
                                  "& fieldset": {
                                    borderColor: "rgba(255,255,255,0.5)",
                                  },
                                  "&:hover fieldset": {
                                    borderColor: "rgba(255,255,255,0.8)",
                                  },
                                },
                              }}
                            />
                          ) : (
                            <Typography
                              variant="h4"
                              sx={{
                                fontWeight: 700,
                                color: "white",
                                mt: 1.5,
                                background: "rgba(255,255,255,0.2)",
                                display: "inline-block",
                                px: 3,
                                py: 1,
                                borderRadius: "20px",
                                backdropFilter: "blur(5px)",
                                fontSize: "1.5rem",
                              }}
                            >
                              {packageData.package_cost
                                ? `Rs ${packageData.package_cost.toLocaleString(
                                    "en-IN"
                                  )}/sqft`
                                : "Loading..."}
                            </Typography>
                          )}
                          <IconButton
                            onClick={
                              editingPackageCost
                                ? handleSavePackageCost
                                : handleEditPackageCost
                            }
                            sx={{ color: "white", ml: 1 }}
                            disabled={isLoading}
                          >
                            {editingPackageCost ? <SaveIcon /> : <EditIcon />}
                          </IconButton>
                        </Box>
                      }
                      sx={{
                        background: pkg.gradient,
                        padding: "30px 20px",
                        textAlign: "center",
                        position: "relative",
                        "&:after": {
                          content: '""',
                          position: "absolute",
                          bottom: 0,
                          left: "50%",
                          transform: "translateX(-50%)",
                          width: "100px",
                          height: "4px",
                          backgroundColor: "rgba(255,255,255,0.5)",
                          borderRadius: "2px",
                        },
                      }}
                    />
                    <Box
                      sx={{
                        background: "#fff",
                        flexGrow: 1,
                        overflowY: "auto",
                        paddingBottom: 2,
                      }}
                    >
                      {pkg.sections.map((section) => (
                        <Accordion
                          key={section.id}
                          expanded={expanded[pkg.id] == section.id}
                          onChange={handleChange(section.id, pkg.id)}
                          sx={{
                            "&:before": { display: "none" },
                            boxShadow: "none",
                            borderBottom: "1px solid rgba(0,0,0,0.05)",
                            backgroundColor:
                              expanded[pkg.id] == section.id
                                ? "rgba(74, 0, 224, 0.03)"
                                : "transparent",
                            transition: "all 0.3s ease",
                            "&:hover": {
                              backgroundColor: "rgba(74, 0, 224, 0.03)",
                            },
                          }}
                        >
                          <AccordionSummary
                            expandIcon={
                              expanded[pkg.id] == section.id ? (
                                <RemoveIcon sx={{ color: pkg.color }} />
                              ) : (
                                <AddIcon sx={{ color: "#666" }} />
                              )
                            }
                            aria-controls={`${section.id}-content`}
                            id={`${section.id}-header`}
                            sx={{
                              padding: "0 25px",
                              minHeight: "68px !important",
                              "& .MuiAccordionSummary-content": {
                                margin: "12px 0",
                                alignItems: "center",
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: 600,
                                color:
                                  expanded[pkg.id] == section.id
                                    ? pkg.color
                                    : "#444",
                                fontSize: "1.2rem",
                                letterSpacing: "0.2px",
                              }}
                            >
                              {section.title}
                            </Typography>
                            <IconButton
                              onClick={(e) => {
                                e.stopPropagation();
                                if (editingField == `${pkg.id}-${section.id}`) {
                                  handleSave(pkg.id, section.id);
                                } else {
                                  handleEdit(
                                    pkg.id,
                                    section.id,
                                    editableContent[
                                      `${pkg.id}-${section.id}`
                                    ] || section.content
                                  );
                                }
                              }}
                              sx={{ marginLeft: "auto" }}
                              disabled={isLoading}
                            >
                              {editingField == `${pkg.id}-${section.id}` ? (
                                <SaveIcon />
                              ) : (
                                <EditIcon />
                              )}
                            </IconButton>
                          </AccordionSummary>
                          <AccordionDetails
                            sx={{
                              padding: "0 25px 25px",
                              backgroundColor: "#fff",
                              borderLeft: `3px solid ${pkg.color}`,
                              marginLeft: "25px",
                              marginBottom: "15px",
                              borderRadius: "0 8px 8px 0",
                              transition: "all 0.3s ease",
                            }}
                          >
                            <Typography
                              variant="body1"
                              sx={{
                                color: "#555",
                                textAlign: "left",
                                lineHeight: "1.8",
                                fontSize: "0.95rem",
                                whiteSpace: "pre-line",
                              }}
                            >
                              {renderContentWithEditableRupeeValues(
                                pkg.id,
                                section.id,
                                editingField == `${pkg.id}-${section.id}`
                                  ? tempContent[`${pkg.id}-${section.id}`]
                                  : editableContent[
                                      `${pkg.id}-${section.id}`
                                    ] || section.content
                              )}
                            </Typography>
                          </AccordionDetails>
                        </Accordion>
                      ))}
                    </Box>
                  </Card>
                </Grow>
              ))
            )}
          </Box>
        </Box>
      </Fade>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ConstructionPackages;
